import * as React from "react"
import T from "../T/T";
import "./styles.scss";

export default function CpaOffers({showReward}) {
    return (
        <div className={`block offer ${showReward ? 'claim' : ''}`}>
            <h1 className="block-title">
                <T>prize-title</T>
            </h1>

            <p className="block-sub-title">
                <T>prize-subtitle-qr</T>

                {/*{ !showReward && (*/}
                {/*    <T>prize-subtitle-no-qr</T>*/}
                {/*)}*/}
            </p>

            <div className="block-content">
                <div className="uk-slider-container-offset di-slider" uk-slider="true" style={{
                    position: "relative"
                }}>
                    <div className="uk-position-relative uk-visible-toggle uk-light" tabIndex="-1">
                        <ul className="uk-slider-items uk-child-width-1-2@s uk-grid">
                            <li>
                                <div className="uk-card uk-card-default">
                                    <div className="uk-card-media-top">
                                        <img src="/static/images/cpa/slide/slide-1.jpg" alt=""/>
                                    </div>
                                    <div className="uk-card-body">
                                        <p><T>slide-1</T></p>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="uk-card uk-card-default">
                                    <div className="uk-card-media-top">
                                        <img src="/static/images/cpa/slide/slide-2.jpg" alt=""/>
                                    </div>
                                    <div className="uk-card-body">
                                        <p><T>slide-2</T></p>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="uk-card uk-card-default">
                                    <div className="uk-card-media-top">
                                        <img src="/static/images/cpa/slide/slide-3.jpg" alt=""/>
                                    </div>
                                    <div className="uk-card-body">
                                        <p><T>slide-3</T></p>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="uk-card uk-card-default">
                                    <div className="uk-card-media-top">
                                        <img src="/static/images/cpa/slide/slide-4.jpg" alt=""/>
                                    </div>
                                    <div className="uk-card-body">
                                        <p><T>slide-4</T></p>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* { !showReward && (
                    <div className="offer-bg">
                        <img src="/static/images/offer-bg.png" alt=""/>
                    </div>
                )} */}
            </div>
        </div>
    )
}
